import z from 'zod';
import { AllCharLabelSchema, SubjectSchema } from '../common/schemas';
import {
  DBNoteHrefSchema,
  DBNoteIsExternalLinkSchema,
  DBNoteKeySchema,
  DBNoteLabelSchema,
  DBNoteNoteIdSchema,
  DBNoteShortLabelSchema,
  NoteHrefSchema,
  NoteIsExternalLinkSchema,
  NoteKeySchema,
  NoteLabelSchema,
  NoteShortLabelSchema,
} from '../notes/schemas';

/**
 * Shared & Helper Schemas
 */

export const DBNotesCategoryNotesEntrySchema = z.object({
  href: z.lazy(() => DBNoteHrefSchema),
  isExternalLink: z.lazy(() => DBNoteIsExternalLinkSchema),
  key: z.lazy(() => DBNoteKeySchema),
  label: z.lazy(() => DBNoteLabelSchema),
  noteId: z.lazy(() => DBNoteNoteIdSchema),
  shortLabel: z.lazy(() => DBNoteShortLabelSchema),
});

export const NotesCategoryNotesEntrySchema = z.object({
  href: z.lazy(() => NoteHrefSchema),
  isExternalLink: z.lazy(() => NoteIsExternalLinkSchema),
  subject: z.lazy(() => SubjectSchema),
  category: z.lazy(() => NotesCategoryCategorySchema),
  key: z.lazy(() => NoteKeySchema),
  label: z.lazy(() => NoteLabelSchema),
  shortLabel: z.lazy(() => NoteShortLabelSchema),
});

/**
 * DB Schemas
 */

export const DBNotesCategorySubjectSchema = SubjectSchema;
export const DBNotesCategoryCategorySchema = z.string().regex(/^[a-zA-Z0-9]{4}$/);
export const DBNotesCategoryLabelSchema = AllCharLabelSchema.min(1).max(64);
export const DBNotesCategoryNotesSchema = z.array(DBNotesCategoryNotesEntrySchema);
export const DBNotesCategoryShortLabelSchema = AllCharLabelSchema.min(1).max(16);

export const DBNotesCategorySchema = z.object({
  subject: DBNotesCategorySubjectSchema,
  category: DBNotesCategoryCategorySchema,
  label: DBNotesCategoryLabelSchema,
  notes: DBNotesCategoryNotesSchema,
  shortLabel: DBNotesCategoryShortLabelSchema,
});

/**
 * Client Schemas
 */

export const NotesCategorySubjectSchema = DBNotesCategorySubjectSchema;
export const NotesCategoryCategorySchema = DBNotesCategoryCategorySchema;
export const NotesCategoryLabelSchema = DBNotesCategoryLabelSchema;
export const NotesCategoryNotesSchema = z.array(NotesCategoryNotesEntrySchema);
export const NotesCategoryShortLabelSchema = DBNotesCategoryShortLabelSchema;

export const NotesCategorySchema = z.object({
  subject: NotesCategorySubjectSchema.meta({ title: 'Subject' }),
  category: NotesCategoryCategorySchema.meta({ title: 'Key' }),
  label: NotesCategoryLabelSchema.meta({ title: 'Label' }),
  notes: NotesCategoryNotesSchema.default([]).meta({ title: 'Notes' }),
  shortLabel: NotesCategoryShortLabelSchema.meta({ title: 'Short label' }),
});
